export function trackOpenAIRegistrationCompleted(response) {
	if (
		typeof window === "undefined" ||
		!response?.data?.success ||
		!window.oaiq
	)
		return;

	window.oaiq("measure", "registration_completed", {
		type: "customer_action",
		amount: 0,
		currency: "USD"
	});
}
